<template>
  <div class="item-name" @click="handleCopy">
    <template v-if="sub">
      <div v-if="item.name_parts.is_stattrak" class="item-category stattrak" :class="{ 'star' : is_star }">
        {{ is_star || `${$t('market.stattrak')} ${item_parts?.type}` }}
      </div>
      <div v-else-if="item.name_parts.is_souvenir" class="item-category souvenir">
        {{ $t('market.souvenir') }} {{ item_parts?.type }}
      </div>
      <div v-else class="item-category" :class="{ 'star' : is_star }">
        {{ item_type }}
      </div>
    </template>
    <div class="value">
      <span>
        {{ item_name || item.name }}
        {{ item_extra_name }}
      </span>
      <div v-if="item.nametag" v-tooltip="{ cloneContent: '.tooltip-content', position: 'center top' }" class="nametag">
        <div class="tooltip-content">
          <span class="name-tag-title">{{ $t('market.nametag') }}:</span>
          <div class="name-tag-content">
            "<span class="name-tag">{{ item.nametag }}</span>"
          </div>
        </div>
        <img src="@/asset/icon/nametag.svg" alt="nametag">
      </div>
    </div>
    <ItemDetails
      v-if="item.quality || item.exterior || item.hero || item.type"
      :item="item"
      :exterior="item.exterior || item.name_parts.quality"
      :quality="item.quality"
      :hero="item.hero"
      :type="item.type"
      :paint_seed="item.paint_seed"
    />
    <ItemDetails v-else-if="sub" :exterior="item.name_parts.quality" :item="item" />
    <template v-if="has_phase_error">
      <div v-tooltip="{ offset: [0, 15], message: $t('errors.steam.item_may_be_incorrect'), position: 'center top' }" class="phase-error">
        <img :src="WarningIcon" alt="">
        <div>
          <span>{{ $t('errors.steam.important') }}</span><span class="desktop-none">: {{ $t('errors.steam.item_may_be_incorrect') }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { getItemExtraName } from '@/hook/market/game.js';
import { copyName } from '@/hook/market/items.js';
import { computed } from 'vue';
import { PhaseEnum } from '@/helper/steam.js';
import ItemDetails from '@/component/item/ItemDetails.vue';
import WarningIcon from '@/asset/icon/warning-triangle-red.svg';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  sub: {
    type: Boolean,
  },
  copy: {
    type: Boolean,
  },
});

const item_parts = computed(() => props.item.name_parts || {});
const is_star = computed(() => {
  if (props.item?.star) {
    const trim_name = item_parts.value.type
      ? item_parts.value.type.split(' ')
      : item_parts.value.subname.split(' ');
    trim_name.shift();

    if (props.item.category) {
      return `${props.item.category} ${trim_name.join(' ').trim()}`;
    }
    return `★ StatTrak™ ${trim_name.join(' ').trim()}`;
  }
  return null;
});

const item_type = computed(() => {
  if (props.item?.star && !item_parts.value?.type) {
    return item_parts.value?.subname;
  }

  return item_parts.value?.type || '';
});

const item_name = computed(() => {
  if (props.item?.star && !item_parts.value?.type) {
    return 'Vanilla';
  }
  return item_parts.value?.subname || '';
});

const sub = computed(() => props.sub && props.item.name_parts);

const handleCopy = (evt) => {
  if (!props.copy) {
    return;
  }
  evt.stopPropagation();
  evt.preventDefault();
  copyName(props.item.name);
};

const item_extra_name = computed(() => getItemExtraName(props.item));

const has_phase_error = computed(() => !props.item?.phase_id && props.item.name?.includes('Doppler'));
</script>
